import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';

var SessionExpired = /*#__PURE__*/function (_Component) {
  _inherits(SessionExpired, _Component);

  var _super = _createSuper(SessionExpired);

  function SessionExpired(props) {
    var _this;

    _classCallCheck(this, SessionExpired);

    _this = _super.call(this, props);

    _this.expireSessionHandler = function () {
      var eventPayload = {
        description: "You've been logged out. Please log in again.",
        code: 5
      };
      Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      var _this$props = _this.props,
          setAuthorized = _this$props.setAuthorized,
          clearToken = _this$props.clearToken,
          setLastPromoCode = _this$props.setLastPromoCode,
          clearPrePurchaseStore = _this$props.clearPrePurchaseStore,
          clearSavedGameInfo = _this$props.clearSavedGameInfo,
          clearAssets = _this$props.clearAssets,
          cleanMissions = _this$props.cleanMissions;
      setAuthorized(false);
      clearToken();
      setLastPromoCode(null);
      clearPrePurchaseStore();
      clearSavedGameInfo();
      clearAssets();
      cleanMissions();
      InboxMessagesProvider.resetInbox();
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };

    if (_this.props.ftueStep) {
      _this.props.setOnboardingFtueStep(_this.props.ftueStep);
    }

    return _this;
  }

  _createClass(SessionExpired, [{
    key: "render",
    value: function render() {
      return this.props.render({
        expireSessionHandler: this.expireSessionHandler
      });
    }
  }]);

  return SessionExpired;
}(Component);

export { SessionExpired as default };